"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySubjectRegisterBulkInitializeStatus = exports.StudySubjectRegisterBulkStatus = void 0;
var StudySubjectRegisterBulkStatus;
(function (StudySubjectRegisterBulkStatus) {
    StudySubjectRegisterBulkStatus["Wait"] = "WAIT";
    StudySubjectRegisterBulkStatus["Processing"] = "PROCESSING";
    StudySubjectRegisterBulkStatus["Processed"] = "PROCESSED";
    StudySubjectRegisterBulkStatus["Failed"] = "FAILED";
})(StudySubjectRegisterBulkStatus = exports.StudySubjectRegisterBulkStatus || (exports.StudySubjectRegisterBulkStatus = {}));
var StudySubjectRegisterBulkInitializeStatus;
(function (StudySubjectRegisterBulkInitializeStatus) {
    StudySubjectRegisterBulkInitializeStatus["Wait"] = "WAIT";
    StudySubjectRegisterBulkInitializeStatus["Processed"] = "PROCESSED";
    StudySubjectRegisterBulkInitializeStatus["Failed"] = "FAILED";
})(StudySubjectRegisterBulkInitializeStatus = exports.StudySubjectRegisterBulkInitializeStatus || (exports.StudySubjectRegisterBulkInitializeStatus = {}));
//# sourceMappingURL=studySubjectRegisterBulk.js.map